export default {
  age: 'Age',
  time: 'Time',
}